/**
 * Kidify blog: live prices past Shopify's 20-product limit.
 *
 * snippets/kidify-live-prices.liquid swaps each price written in a post as
 * <span data-kidify-price="handle"> for the product's live price. Shopify
 * looks up at most 20 products per page, so in longer posts the rest come
 * out as data-kidify-price-pending. This fills them in from the product
 * card template (/products/<handle>?view=kidify-card through fetchCard()
 * in assets/kidify-shelf.js), whose price HTML is the same kidify-card-price
 * snippet. Nothing here decides a price rule. A handle that no longer
 * exists keeps the text written in the post.
 *
 * Several handles show the cheapest in stock (or the cheapest of all if
 * none is), with "From " when the prices differ, as the snippet does.
 */

const fill = async (span, fetchCard) => {
  const handles = span.dataset.kidifyPricePending.split(' ').filter(Boolean);
  const cards = (await Promise.all(handles.map((handle) => fetchCard(handle)))).map((result) => result.card).filter(Boolean);
  if (!cards.length) return;

  const cheapest = (list) => list.reduce((best, card) => (!best || card.priceMin < best.priceMin ? card : best), null);
  const best = cheapest(cards.filter((card) => card.available)) || cheapest(cards);
  const top = Math.max(...cards.map((card) => card.priceMax));
  const from = handles.length > 1 && !best.priceVaries && top > best.priceMin ? 'From ' : '';

  const template = document.createElement('template');
  template.innerHTML = best.priceHtml;
  // The card template renders the price with the shelf's class; in the text it takes the post's styling.
  template.content.querySelectorAll('.kidify-shelf__price').forEach((el) => el.classList.remove('kidify-shelf__price'));
  span.replaceChildren(from, template.content);
  span.removeAttribute('data-kidify-price-pending');
};

const run = () => {
  const fetchCard = window.Kidify?.fetchCard;
  if (!fetchCard) return;
  document.querySelectorAll('.blog-post-content [data-kidify-price-pending]').forEach((span) => fill(span, fetchCard));
};

// assets/kidify-shelf.js loads in the head, so it is normally ready; wait for load if not.
if (window.Kidify?.fetchCard) run();
else window.addEventListener('load', run, { once: true });
